<template>
  <v-app id="settings" class="mb-12">
    <v-container class="grid-list-lg pa-0 mt-6">
      <div class="wrap-settings mb-6">
        <div class="settings-top-header">
          <!-- <div class="caption">SETTINGS</div> -->
          <h2 class="headline">Settings</h2>
        </div>
      </div>
      <v-layout class="wrap">
          <v-flex v-for="item in filteredItems" :key="item.link" class="xs12 md6">
            <v-hover>
              <v-card slot-scope="{ hover }" :ripple="false" :class="`elevation-${hover ? 6 : 2}`" @click="$router.push(item.link)" class="pa-6 pointer" >
                <v-layout class="align-center fill-height">
                  <v-flex class="py-2 px-4">
                      <div class="small-title my-1">{{ item.name }}</div>
                      <div class="text-body-2 pt-2">{{ item.description }}</div>
                  </v-flex>
                  <v-flex class="shrink py-2 px-1">
                    <v-layout class="align-center fill-height px-2">
                      <v-flex
                        class="action-link pa-0 hidden-sm-and-down" 
                      >VIEW</v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
          </v-hover>
          </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Settings',
  data () {
    return {
      no_data: [null, '', undefined, 'null'],
      items: [
        { 
          name: 'Client Onboarding',
          link: '/settings/client_onboarding',
          permission: 'client_onboarding',
          description: 'Specify residential service area, new client onboarding settings, email settings and terms of service.'
        },
        { 
          name: 'Billing',
          link: '/settings/billing_settings',
          permission: 'billing_settings',
          description: 'Manage billing option, interval, sales tax, start of billing cycle, net terms, invoice options and more.'
        },
        { name: 'Pricing Setup',
          link: '/settings/pricing_setup',
          permission: 'pricing_setup',
          description: 'Enter regular and initial/one time cleanup prices. Optionally specify custom prices for one time and initial cleanups.'
        },
        { 
          name: 'Scheduler',
          link: '/settings/scheduler_settings',
          permission: 'scheduler_settings',
          description: 'Create jobs in advance, improve routing within gated communities and update field tech related settings.'
        },
        { 
          name: 'Residential Cross-Sells',
          link: '/settings/residential_cross_sells',
          permission: 'additional_services',
          description: 'Specify additional services and products for dog owners. Choose display option during client onboarding.'
        },
        { 
          name: 'Commercial Cross-Sells',
          link: '/settings/commercial_cross_sells',
          permission: 'additional_commercial_services',
          description: 'Specify additional services and products for communities. Typical cross-sells include bags and more.'
        },
        { 
          name: 'Quickbooks Online',
          link: '/settings/quickbooks_online',
          permission: 'quickbooks_online',
          description: 'Connect to QBO, manage connections, view transaction log and update QBO account type used for deposits.'
        },
        { 
          name: 'Payroll',
          link: '/settings/payroll_settings',
          permission: 'payroll_settings',
          description: 'Edit staff compensation options per staff member. Basic options include hourly, commission, per yard and fixed pay.'
        },
        { 
          name: 'Field Tech App',
          link: '/settings/field_tech_app_settings',
          permission: 'field_tech_app_settings',
          description: 'Customize field tech app options including Google directions, notes and photos to clients and data privacy.'
        },
        { 
          name: 'Client Portal',
          link: '/settings/client_portal_settings',
          permission: 'client_portal_settings',
          description: 'Copy client onboarding and client portal links and decide what contact info to display to logged in clients.'
        },
        { 
          name: 'Branding',
          link: '/settings/branding_settings',
          permission: 'branding_settings',
          description: 'Personalize new and existing client experience with your logo, color and contact information.'
        },
        { 
          name: 'Customize Dashboard',
          link: '/settings/customize_dashboard', 
          permission: 'customize_dashboard',
          description: 'Manage dashboard widgets, shortcuts and assistance information display. Each staff member can update their own.'
        },
        { 
          name: 'Ratings & Comments/Tipping',
          link: '/settings/ratings_comments_and_tipping',
          permission: 'ratings_comments_and_tipping_settings',
          description: 'Let clients rate and tip field techs and choose if field techs may see client ratings & comments.'
        },
        { 
          name: 'Open API',
          link: '/settings/open_api',
          permission: 'open_api',
          description: 'Let your web developer use our API and webhooks to integrate your Sweep&Go account with 3rd party applications.'
        },
        { 
          name: 'Royalty Payments',
          link: '/settings/royalty_payments',
          permission: 'royalty_payments',
          description: 'View your royalty invoices and payments as well as manage your bank account.'
        },
        { 
          name: 'Directory Listing',
          link: '/settings/directory_listing',
          permission: 'directory_listing',
          description: 'Manage your gotpooperscooper.com directory listing.'
        },
        { 
          name: 'Subscription Details',
          link: '/settings/subscription_details',
          permission: 'subscription_details',
          description: 'Manage your subscription details, add a different credit card on file and view transaction history.'
        },
        // { 
        //   name: 'Time and Date',
        //   link: '/settings/time_and_date_settings',
        //   permission: 'branding_settings',
        //   description: ''
        // }
      ]
    }
  },
  computed: {
    ...mapGetters(['permissions', 'belongsToFranchise']),
    filteredItems () {
      return this.items
        .filter(i => this.permissions.includes(i.permission))
        .filter(i => i.permission !== 'royalty_payments' || this.belongsToFranchise)
    }
  }
}
</script>